import * as React from 'react'
import { FetchFirmTasksQuery, TaskType } from '../types.gen'
import TableMultiselect from './TableMultiselect'
import { ColoredSpan } from './core'

type Task = FetchFirmTasksQuery['firm']['tasks'][0]

interface TasksTMultiSelProps {
  tasks: Task[]
  onChange?: (keys: Set<string | number>) => void
}

/**
 * See TableMultiselect.
 *
 * Provides multiselect table for a list of tasks.
 */
export class TasksTableMultiselect extends React.PureComponent<TasksTMultiSelProps> {
  private tasksTableGetId = (task: Task) => task.id

  render() {
    const { tasks, onChange } = this.props

    const cols = [(task: Task) => <ColoredSpan color="midway">{task.displayName}</ColoredSpan>]

    const filteredTasks = tasks.filter(
      task =>
        task.taskType !== TaskType.LEASING_FIRM &&
        (task.offboardDate == null || new Date(task.offboardDate) > new Date())
    )

    return (
      <TableMultiselect
        rows={filteredTasks}
        columns={cols}
        headers={['All properties']}
        widths={['230px', null, null]}
        alignments={['left', 'right', 'right']}
        onChange={onChange}
        keyFn={this.tasksTableGetId}
      />
    )
  }
}
